"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Carrousel = void 0;
var _react = require("react");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _Carrousel = require("./Carrousel.styles");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Carrousel = function Carrousel(props) {
  var _props$items = props.items,
    items = _props$items === void 0 ? [] : _props$items,
    _props$index = props.index,
    index = _props$index === void 0 ? 0 : _props$index,
    width = props.width;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    direction = _useContext.direction;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    getMeasurement = _useStylesUtils.getMeasurement;
  var previousIndexRef = (0, _react.useRef)(null);
  var styles = (0, _Carrousel.useStyles)(props);
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    containerStyle = _useState2[0],
    setContainerStyle = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    incomingStyle = _useState4[0],
    setIncomingStyle = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    outgoingStyle = _useState6[0],
    setOutgoingStyle = _useState6[1];
  var transitionTimeout = (0, _react.useRef)(null);
  var currentRef = (0, _react.useRef)(null);
  var incomingRef = (0, _react.useRef)(null);
  var outgoingRef = (0, _react.useRef)(null);
  var _useState7 = (0, _react.useState)(index),
    _useState8 = _slicedToArray(_useState7, 2),
    currentIndex = _useState8[0],
    setCurrentIndex = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState9, 2),
    incomingIndex = _useState10[0],
    setIncomingIndex = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    outgoingIndex = _useState12[0],
    setOutgoingIndex = _useState12[1];

  //initialize current item for the first time
  (0, _react.useEffect)(function () {
    var _currentRef$current$c, _currentRef$current, _currentRef$current$c2, _currentRef$current2;
    setContainerStyle((0, _css.css)({
      width: width ? getMeasurement(width) : (_currentRef$current$c = (_currentRef$current = currentRef.current) === null || _currentRef$current === void 0 ? void 0 : _currentRef$current.clientWidth) !== null && _currentRef$current$c !== void 0 ? _currentRef$current$c : 'auto',
      height: (_currentRef$current$c2 = (_currentRef$current2 = currentRef.current) === null || _currentRef$current2 === void 0 ? void 0 : _currentRef$current2.clientHeight) !== null && _currentRef$current$c2 !== void 0 ? _currentRef$current$c2 : 'auto',
      transition: 'width 0s ease-in-out, height 0s ease-in-out'
    }));
  }, [getMeasurement, width]);
  (0, _react.useEffect)(function () {
    setContainerStyle((0, _css.css)({
      width: width ? getMeasurement(width) : 'fit-content',
      height: 'auto'
    }));
    setIncomingStyle((0, _css.css)({}));
    setOutgoingStyle((0, _css.css)({}));
    if (transitionTimeout.current !== null) {
      window.clearTimeout(transitionTimeout.current);
      transitionTimeout.current = null;
    }
    var newIndex = index < 0 || index >= items.length ? index % items.length : index;
    if (previousIndexRef.current !== null) {
      setCurrentIndex(null);
      setIncomingIndex(newIndex);
      setOutgoingIndex(previousIndexRef.current);
    }
    previousIndexRef.current = newIndex;
    transitionTimeout.current = window.setTimeout(function () {
      setCurrentIndex(newIndex);
      setIncomingIndex(null);
      setOutgoingIndex(null);
    }, 510);
  }, [getMeasurement, index, items.length, width]);
  (0, _react.useEffect)(function () {
    if (incomingIndex !== null && outgoingIndex !== null) {
      var _outgoingRef$current$, _outgoingRef$current, _outgoingRef$current$2, _outgoingRef$current2;
      var animateDirection = direction === 'rtl' && incomingIndex > outgoingIndex || direction !== 'rtl' && incomingIndex <= outgoingIndex ? 'right' : 'left';
      if (incomingIndex === 0 && Math.abs(outgoingIndex) === items.length - 1 || outgoingIndex === 0 && Math.abs(incomingIndex) === items.length - 1) {
        animateDirection = animateDirection === 'right' ? 'left' : 'right';
      }
      setContainerStyle((0, _css.css)({
        width: width ? getMeasurement(width) : (_outgoingRef$current$ = (_outgoingRef$current = outgoingRef.current) === null || _outgoingRef$current === void 0 ? void 0 : _outgoingRef$current.clientWidth) !== null && _outgoingRef$current$ !== void 0 ? _outgoingRef$current$ : 'auto',
        height: (_outgoingRef$current$2 = (_outgoingRef$current2 = outgoingRef.current) === null || _outgoingRef$current2 === void 0 ? void 0 : _outgoingRef$current2.clientHeight) !== null && _outgoingRef$current$2 !== void 0 ? _outgoingRef$current$2 : 'auto',
        overflow: 'hidden',
        transition: 'width 0s ease-in-out, height 0s ease-in-out'
      }));
      setIncomingStyle((0, _css.css)({
        opacity: 0,
        right: animateDirection === 'right' ? '100%' : 'unset',
        left: animateDirection === 'right' ? 'unset' : '100%'
      }));
      setOutgoingStyle((0, _css.css)({
        opacity: 1,
        left: animateDirection === 'right' ? '0%' : 'unset',
        right: animateDirection === 'right' ? 'unset' : '0%',
        transition: 'opacity .5s ease-in-out, right .5s ease-in-out, left .5s ease-in-out'
      }));
      setTimeout(function () {
        var _incomingRef$current$, _incomingRef$current, _incomingRef$current$2, _incomingRef$current2;
        setContainerStyle((0, _css.css)({
          width: width ? getMeasurement(width) : (_incomingRef$current$ = (_incomingRef$current = incomingRef.current) === null || _incomingRef$current === void 0 ? void 0 : _incomingRef$current.clientWidth) !== null && _incomingRef$current$ !== void 0 ? _incomingRef$current$ : 'auto',
          height: (_incomingRef$current$2 = (_incomingRef$current2 = incomingRef.current) === null || _incomingRef$current2 === void 0 ? void 0 : _incomingRef$current2.clientHeight) !== null && _incomingRef$current$2 !== void 0 ? _incomingRef$current$2 : 'auto',
          overflow: 'hidden',
          transition: 'width .5s ease-in-out, height .5s ease-in-out'
        }));
        setIncomingStyle((0, _css.css)({
          opacity: 1,
          right: animateDirection === 'right' ? '0%' : 'unset',
          left: animateDirection === 'right' ? 'unset' : '0%'
        }));
        setOutgoingStyle((0, _css.css)({
          opacity: 0,
          left: animateDirection === 'right' ? '100%' : 'unset',
          right: animateDirection === 'right' ? 'unset' : '100%'
        }));
      }, 1);
    }
  }, [direction, getMeasurement, incomingIndex, index, items.length, outgoingIndex, width]);
  if (!items.length) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-id": "container",
    className: "".concat(styles['cc-Carrousel'], " ").concat(containerStyle),
    children: [currentIndex !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-id": "current",
      ref: currentRef,
      className: "".concat(styles['cc-Carrousel__current-item']),
      children: items.at(currentIndex)
    }), incomingIndex !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-id": "incoming",
      ref: incomingRef,
      className: "".concat(styles['cc-Carrousel__swapped-item'], " ").concat(incomingStyle),
      children: items.at(incomingIndex)
    }), outgoingIndex !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-id": "outgoing",
      ref: outgoingRef,
      className: "".concat(styles['cc-Carrousel__swapped-item'], " ").concat(outgoingStyle),
      children: items.at(outgoingIndex)
    })]
  });
};
exports.Carrousel = Carrousel;